import { AfterViewInit, Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { Constants } from '../app.constants';
import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { ScriptService } from '../script.service';
import { ReCaptchaComponent } from 'angular2-recaptcha';

import { UserService } from '../user.service';

declare var Plaid: any;

@Component({
  //selector: '[linkInitialize]',
  selector: 'echexpayment-bankauth-url',
  templateUrl: './bankauth-url.component.html',
  styleUrls: ['./generate-bankauth-url.component.css']
})
export class BankauthUrlComponent implements OnInit, AfterViewInit , OnDestroy{
	 @ViewChild('submitButton') submitButton: ElementRef;

	public bankAuthLink : any = {};
	public ptoken : any = {};
    busy: Subscription;
	linkHandler: any;
	
	
   	public plaid_public_token :string;
	public amountInWords :string;
	public plaid_public_key :string;
	public account_checking :string;
	public plaid_link_token :string;
	
	public today_date: Date;
	
	public val_name:boolean=false;
	public val_email:boolean=false;
	public invalidEmalAddress:boolean=false;
	public val_description:boolean=false;
	public val_check_amount:boolean=false;
	
	public disable:boolean=false;
	public key:string;

	public isCaptchaValid : boolean = false;

	public RedirectUrlLink : any = {};
	public secureUrlLink : any = {};
	public getPhoneNumber : any = {};
	public logo_image : any = {};

	public tokenj:string;
	public bankname:string;
	public bankaddress:string;
	public bankcity:string;
	public bankzip:string;
	public chequeerror_res:string;
	public formTouched : boolean = false;
	public showWarning: boolean = false;
	public characterLimitReached : boolean = false;
	NamecharacterLimitReached: { [key: string]: boolean } = {};

	@ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;
	@ViewChild('Focus_Captcha', { read: ElementRef }) focusCaptchaRef: ElementRef;
	
	constructor(private router: Router, private elementRef: ElementRef, private renderer: Renderer2, private route: ActivatedRoute,private userService:UserService, private toastr: ToastrService, private echexpaymentService :EchexpaymentService, private scriptService :ScriptService, private localStorageService: LocalstorageService, private CONSTANTS: Constants) { 

		this.router = router;
		this.today_date =  new Date(); 
		this.plaid_public_key = CONSTANTS.plaid_public_key;
		this.key = CONSTANTS.captcha_key;

	
	}

	ngOnDestroy() {
		this.toastr.clear();
	}

	ngOnInit() {
		this.getBankInfo();
		let params: any = this.route.snapshot.params;			
	}

	focusFirstInvalidControlPlus(): void {
		const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
		if (firstElementWithErrors) {
			firstElementWithErrors.focus();
		}
	}

	
	moveNext(nextInput: HTMLInputElement, number: number) {
		let captchaToken = this.captcha.getResponse();
		if(number === 3){
			if(captchaToken){
				if (this.submitButton && this.submitButton.nativeElement) {
					this.submitButton.nativeElement.focus();
					this.submitButton.nativeElement.click();
				}
			} else {
				setTimeout(() => {
					const iframeElement = this.focusCaptchaRef.nativeElement.querySelector('iframe');
					if (iframeElement) {
					iframeElement.focus();
					iframeElement.click();
					}
				}, 100);
		    }
		} else if(number === 2){
			if (this.submitButton && this.submitButton.nativeElement) {
				this.submitButton.nativeElement.focus();
				this.submitButton.nativeElement.click();
			}
	   } else{
		nextInput && nextInput.focus();
	   }
	}

	ngAfterViewInit(){
		this.renderer.selectRootElement('#Initialfocus').focus();
		this.scriptService.load('Plaid').then(data => {
			this.loadPopUp();
		}).catch(error => console.log(error));
	}
	
	handleCorrectCaptcha(){
		let captchaToken = this.captcha.getResponse();
		// if(captchaToken){
		// 	const saveButton = document.getElementById('submitButton') as HTMLElement;
		// 	if (saveButton) {
		// 		saveButton.focus();
		// 		setTimeout(()=>{
		// 		   saveButton.click();
		// 		}, 1000)
		// 	}
		// }
		this.isCaptchaValid = false;
	}

	// Get Bank Info
	getBankInfo(){
	     
		let params: any = this.route.snapshot.params;
		var data = {
			id :params._id,
    		token :params.token
		}
		let responseData = <any>{};
    	this.busy = this.echexpaymentService.getBankInfoApi(data).subscribe(
	       response => {
				responseData = response;
				this.RedirectUrlLink = responseData.data.thank_you_url;
				this.bankAuthLink.transcation_fee =  responseData.data.transcation_fee;
				if(responseData.data.cheque_amount != ''){
					const result = parseFloat(responseData.data.cheque_amount) + parseFloat(this.bankAuthLink.transcation_fee);
                    this.bankAuthLink.bank_auth_amount = result !== 0.00 ? result.toFixed(2) : '';
					var amt = this.bankAuthLink.bank_auth_amount;
					this.bankAuthLink.amount = amt;
					this.amountToWords(amt);
					// this.amountInWords = this.echexpaymentService.toWords(amt);
					this.tokenj = responseData.data.user_token;  //add address
				}
				this.secureUrlLink.toname =  responseData.data.pay_to_the_order_of;
				this.getPhoneNumber = responseData.data.phone_number;
				this.logo_image = responseData.data.logo_image;
				
	      	  this.bankAuthLink.pay_to_the_order_of =  responseData.data.pay_to_the_order_of;
	      	  this.bankAuthLink.bank_auth_memo =  responseData.data.memo;
	      	  this.bankAuthLink.descriptiondata  = responseData.data.memo;
	       },
	       error => {
			responseData = error;
			this.chequeerror_res = responseData.error.message;
	        //this.toastr.error(responseData.error.message, 'Failed!');
	       }
   		);
	}
	
	// Amount to words
	// amountToWords(value){
	// 	this.amountInWords = this.echexpaymentService.toWords(value);
	// }
	
	amountToWords(value) {
		if (value < 999999999) {
			this.showWarning = false;
		} 
		if (value === null || value === undefined) {
		  this.amountInWords = '';
		} else {
		  const dollars = Math.floor(value);
		  const cents = Math.round((value - dollars) * 100);
		  let centsText = '';
	  
		  if (cents !== 0) {
			centsText = `${cents}/100`;
		  }
	  
		  this.amountInWords = `${this.echexpaymentService.toWords(dollars)}`;
	  
		  if (centsText) {
			this.amountInWords += ` and ${centsText} Cents`;
		  } else {
			this.amountInWords += ` and 00/100 Cents`;
		  }
	    }
	  }

	  DisallowZero(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
      
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
          // Allow the default behavior for certain keys
          return;
        }
      
        const inputValue = event.target.value;
        const caretStart = event.target.selectionStart;
        const caretEnd = event.target.selectionEnd;
        const modifiedValue = inputValue.slice(0, caretStart) + event.key + inputValue.slice(caretEnd);
        
        if (modifiedValue !== '' && !/^\d*\.?\d*$/.test(modifiedValue)) { 
        //  this.showWarning = false; // Hide the warning message
          event.preventDefault(); // Prevent invalid input
          return;
        }
        const regex = /^\d{0,9}(\.\d{0,2})?$/;
        const maxValue = 999999999;
        if (!regex.test(modifiedValue) || parseFloat(modifiedValue) > maxValue) {
          if (parseFloat(modifiedValue) > maxValue) {
            this.showWarning = true;
            setTimeout(() => {
              this.showWarning = false;
            }, 3000);
            event.preventDefault();
          } else{
			this.showWarning = false;
		  }
          event.preventDefault();
        } 
      }
	//setAmountValue
    setAmountValueForBankAuth(amount){
		if(amount) {
			this.bankAuthLink.bank_auth_amount = parseFloat(amount).toFixed(2);
		}      
    }
	
	// loadPopUp
	loadPopUp(){
		let data = {"user_token" : ''};
        let responseData = <any>{};
        this.busy =  this.userService.ConectBankV2(data).subscribe(
        response => {
            responseData = response;
            this.plaid_link_token = responseData.data.link_token;
			this.linkHandler =  Plaid.create({
				token:this.plaid_link_token,
				onSuccess: function(public_token, metadata) {
						((document.getElementById("publictoken") as HTMLInputElement).value) = public_token;
						var l = document.getElementById('submitToGetInfo');
						l.click();
				},
				onExit: function(err, metadata) {
					// The user exited the Link flow.
					if (err != null) {
					
					}
					
				}
			});
		});
	}
	

	//eventHandler
    eventHandler(){
        this.val_name = false;
        this.val_email = false;
        this.invalidEmalAddress = false;
        this.val_description = false;
        this.val_check_amount = false;
    }
	// Open Plaid popup
  	openPlaid(data){
		this.focusFirstInvalidControlPlus();   //focus field
        this.formTouched = true;
		if(data.valid){
			if (parseFloat(data.value.bank_auth_amount) > 999999999) {
				this.showWarning = true;
				return;
			} 
		    let model: any = data.value;
			// validate captcha
			let captcha_GetToken = this.captcha.getResponse();
			if (captcha_GetToken) {
				this.isCaptchaValid = false;
			} else{
				this.isCaptchaValid = true;
				return false;
			}

		    this.linkHandler.open();
		} else{
			if (parseFloat(data.value.bank_auth_amount) > 999999999) {
				console.log(data.value.bank_auth_amount, 'data')
				this.showWarning = true;
				return;
			} 
		}
  	}

	// get info from Plaid
  	getInfoFromPlaid(){
		var public_token = ((document.getElementById("publictoken") as HTMLInputElement).value);
		var bank_auth_amount = ((document.getElementById("bank_auth_amount") as HTMLInputElement).value);

	  	var data = {
			PlaidInfo :true,
			token :public_token,
			amount :bank_auth_amount,
	  	}
		let responseData = <any>{};
	  	this.busy = this.echexpaymentService.getInfoFromPlaidApi(data).subscribe(
	       response => {
				this.disable = true;
				responseData = response;
				this.toastr.success('Required amount available in your account', '');
				this.bankAuthLink.account_checking = responseData.data.account_checking;
				this.bankAuthLink.routing_checking = responseData.data.routing_checking;
				this.bankAuthLink.check_number     = responseData.data.check_number;
				this.getRoutingInfo(responseData.data.routing_checking);
	       },
	       error => {
				responseData = error;
				this.chequeerror_res = responseData.error.message;
				// this.toastr.error(responseData.error.message, 'Failed!');
	       }
   		);
  	}


	// get routing info
	getRoutingInfo(routing_number){
        let params: any = this.route.snapshot.params;
		if(routing_number.length >=9)
		{
		 let data = {
		  user_token:this.tokenj,
          token:params._id,
		  id:params._id,
		  routing_number:routing_number
		}
		let responseData = <any>{};
		this.userService.getRoutingInfoApi(data).subscribe(
		 response => {
			responseData = response;
			this.chequeerror_res = '';
			this.bankname = responseData.data.name;
			this.bankaddress = responseData.data.address;
			this.bankcity = responseData.data.city;
			this.bankzip = responseData.data.zip;

		 }, 
		 error => {
			responseData = error;
			this.chequeerror_res = responseData.error.message;
			//this.toastr.error(responseData.error.message, 'Failed!');
		 }
		); 
		}
    }



	// Save cheque from bank auth
  	payChequeFromBankAuth(model){
	console.log(this.bankAuthLink, 'this.bankAuthLink')
		let params: any = this.route.snapshot.params;
  		var data = {
  			cheque_link_type : 'bank_auth_link',
  			_id :params._id,
    		cheque_token :params.token,
    		name :this.bankAuthLink.bank_auth_name,
    		email :this.bankAuthLink.bank_auth_email,
    		to_name :this.bankAuthLink.pay_to_the_order_of,
    		checking_account_number :this.bankAuthLink.account_checking,
    		amount :this.bankAuthLink.bank_auth_amount,
    		cheque_number :this.bankAuthLink.check_number,
    		memo :this.bankAuthLink.bank_auth_memo,
    		routing_number :this.bankAuthLink.routing_checking,
    		cheque_signature :this.bankAuthLink.bank_auth_name,
  		}
		let responseData = <any>{};
  		this.busy = this.echexpaymentService.payChequeFromBankAuthApi(data).subscribe(
	       response => {
			responseData = response;
			if (this.RedirectUrlLink) {
                window.location.href = this.RedirectUrlLink;
            } else {
                this.router.navigate(['/thank-you-url']);
            }
	       },
	       error => {
				responseData = error;
				this.chequeerror_res = responseData.error.message;
				//this.toastr.error(responseData.error.message, 'Failed!');
	       }
   		);
  		
  	}

	limitDecimalLength(inputElement: HTMLInputElement) {
		const regex = /^\d{0,9}(\.\d{0,2})?$/;
		const inputValue = inputElement.value;
		
		if (!regex.test(inputValue)) {
			inputElement.value = inputValue.slice(0, -1);
		}
	}

	checkCharacterLimit(event: any) {
		const maxTextLength = 20; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  return;
		}
		const inputValue = event.target.value;
		
		if (inputValue.length >= maxTextLength) {
		  if (allowedKeys.indexOf(inputChar) === -1) {
		  this.characterLimitReached = true; // Set the validation flag to true to show the warning message
		  setTimeout(() => {
			this.characterLimitReached = false; // Hide the warning message after 3 seconds
		  }, 3000);
		  event.preventDefault(); // Prevent entering the exceeded character
		  }
		}
	  }
	  
	  //Length validation
	  NameCharacterLimit(event: any, fieldName: string, max_length:number) {
		const maxTextLength = max_length; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
			return;
		}
	
		const inputValue = event.target.value;
	
		if (inputValue.length >= maxTextLength) {
			if (allowedKeys.indexOf(inputChar) === -1) {
				this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
				setTimeout(() => {
				this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
				}, 3000);
				event.preventDefault(); // Prevent entering the exceeded character
			}
		}
	}
	isNameLimitReached(fieldName: string): boolean {
		return this.NamecharacterLimitReached[fieldName];
	  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/generate-bankauth-url/bankauth-url.component.ts